import apiService from "../../api/api.service";
import { FooterResponse } from "./footer.types";

export const fetchFooter = () => {
  return apiService.get<FooterResponse>("/general/footer");
};